import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import { useHydrated } from '../hooks/useHydrated';
import { useTranslation } from '../hooks/useTranslation';
import { tamilFestivalTamil } from '../data/festivalTamil';
import './TamilFestivals.css';

const tamilFestivalData = [
  {
    month: 'January',
    tamilMonth: 'Thai',
    festivals: [
      { date: 'Jan 3', name: 'Arudra Darshan (Thiruvathirai)', type: 'Major' },
      { date: 'Jan 13', name: 'Bhogi Pandigai', type: 'Pongal' },
      { date: 'Jan 14', name: 'Thai Pongal (Surya Pongal)', type: 'Pongal' },
      { date: 'Jan 15', name: 'Mattu Pongal', type: 'Pongal' },
      { date: 'Jan 16', name: 'Kaanum Pongal / Thiruvalluvar Day', type: 'Pongal' },
      { date: 'Jan 17', name: 'Uzhavar Thirunal (Farmers\' Day)', type: 'Festival' },
      { date: 'Jan 18', name: 'Thai Amavasai', type: 'Amavasai' },
      { date: 'Jan 25', name: 'Ratha Saptami', type: 'Festival' },
    ],
  },
  {
    month: 'February',
    tamilMonth: 'Masi',
    festivals: [
      { date: 'Feb 1', name: 'Thaipusam (Thai Poosam)', type: 'Major' },
      { date: 'Feb 15', name: 'Maha Shivaratri', type: 'Major' },
    ],
  },
  {
    month: 'March',
    tamilMonth: 'Masi / Panguni',
    festivals: [
      { date: 'Mar 3', name: 'Masi Magam', type: 'Major' },
      { date: 'Mar 14', name: 'Karadaiyan Nombu', type: 'Vrat' },
      { date: 'Mar 26', name: 'Rama Navami', type: 'Festival' },
    ],
  },
  {
    month: 'April',
    tamilMonth: 'Panguni / Chithirai',
    festivals: [
      { date: 'Apr 1', name: 'Panguni Uthiram', type: 'Major' },
      { date: 'Apr 14', name: 'Tamil New Year (Puthandu)', type: 'Major' },
      { date: 'Apr 19', name: 'Akshaya Tritiyai', type: 'Festival' },
      { date: 'Apr 19', name: 'Chithirai Thiruvizha Begins', type: 'Major' },
      { date: 'Apr 28', name: 'Meenakshi Thirukalyanam', type: 'Major' },
    ],
  },
  {
    month: 'May',
    tamilMonth: 'Chithirai / Vaikasi',
    festivals: [
      { date: 'May 1', name: 'Chitra Pournami', type: 'Pournami' },
      { date: 'May 30', name: 'Vaikasi Visakam', type: 'Major' },
    ],
  },
  {
    month: 'June',
    tamilMonth: 'Vaikasi / Aani',
    festivals: [
      { date: 'Jun 14', name: 'Aani Thirumanjanam', type: 'Major' },
      { date: 'Jun 29', name: 'Aani Pournami', type: 'Pournami' },
    ],
  },
  {
    month: 'July',
    tamilMonth: 'Aani / Aadi',
    festivals: [
      { date: 'Jul 14', name: 'Aadi Amavasai (Early)', type: 'Amavasai' },
      { date: 'Jul 16', name: 'Aadi Month Begins (Aadi Pirappu)', type: 'Major' },
      { date: 'Jul 21', name: 'Aadi Chevvai', type: 'Festival' },
      { date: 'Jul 25', name: 'Aadi Kiruthigai', type: 'Festival' },
      { date: 'Jul 29', name: 'Aadi Pournami', type: 'Pournami' },
    ],
  },
  {
    month: 'August',
    tamilMonth: 'Aadi / Avani',
    festivals: [
      { date: 'Aug 3', name: 'Aadi Perukku', type: 'Major' },
      { date: 'Aug 12', name: 'Aadi Amavasai', type: 'Amavasai' },
      { date: 'Aug 14', name: 'Andal Jayanthi', type: 'Festival' },
      { date: 'Aug 26', name: 'Avani Avittam (Rigveda)', type: 'Major' },
      { date: 'Aug 27', name: 'Avani Avittam (Yajurveda)', type: 'Major' },
      { date: 'Aug 28', name: 'Varalakshmi Vratam / Gayathri Japam', type: 'Vrat' },
    ],
  },
  {
    month: 'September',
    tamilMonth: 'Avani / Purattasi',
    festivals: [
      { date: 'Sep 4', name: 'Gokulashtami (Krishna Jayanthi)', type: 'Major' },
      { date: 'Sep 14', name: 'Vinayagar Chaturthi (Pillaiyar Chaturthi)', type: 'Major' },
    ],
  },
  {
    month: 'October',
    tamilMonth: 'Purattasi / Aippasi',
    festivals: [
      { date: 'Oct 10', name: 'Mahalaya Amavasai', type: 'Amavasai' },
      { date: 'Oct 11', name: 'Navaratri Begins', type: 'Major' },
      { date: 'Oct 20', name: 'Ayudha Pooja / Saraswati Pooja / Vijayadashami', type: 'Major' },
      { date: 'Oct 21', name: 'Vidyarambham', type: 'Festival' },
    ],
  },
  {
    month: 'November',
    tamilMonth: 'Aippasi / Karthigai',
    festivals: [
      { date: 'Nov 8', name: 'Deepavali (Lakshmi Puja)', type: 'Major' },
      { date: 'Nov 10', name: 'Skanda Sashti Begins', type: 'Major' },
      { date: 'Nov 15', name: 'Soora Samharam', type: 'Major' },
      { date: 'Nov 24', name: 'Karthigai Deepam', type: 'Major' },
    ],
  },
  {
    month: 'December',
    tamilMonth: 'Karthigai / Margazhi',
    festivals: [
      { date: 'Dec 15', name: 'Subrahmanya Sashti', type: 'Festival' },
      { date: 'Dec 20', name: 'Vaikunta Ekadashi', type: 'Major' },
      { date: 'Dec 24', name: 'Arudra Darshan (Thiruvathirai)', type: 'Major' },
    ],
  },
];

const typeColors = {
  Major: '#e65100',
  Pongal: '#d84315',
  Vrat: '#6a1b9a',
  Pournami: '#f9a825',
  Amavasai: '#37474f',
  Festival: '#2e7d32',
};

const typeLabels = ['All', 'Major', 'Pongal', 'Vrat', 'Pournami', 'Amavasai', 'Festival'];

const TamilFestivals = () => {
  const currentYear = new Date().getFullYear();
  const [filter, setFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const hydrated = useHydrated();
  const { t, lang } = useTranslation();

  const tf = (name) => lang === 'ta' && tamilFestivalTamil[name] ? tamilFestivalTamil[name] : name;

  const typeTranslations = {
    All: t('tamilFestivals.all'),
    Major: t('tamilFestivals.major'),
    Pongal: t('tamilFestivals.pongal'),
    Vrat: t('tamilFestivals.vrat'),
    Pournami: t('tamilFestivals.pournami'),
    Amavasai: t('tamilFestivals.amavasai'),
    Festival: t('tamilFestivals.festivalType'),
  };

  const filteredData = tamilFestivalData
    .map((monthData) => ({
      ...monthData,
      festivals: monthData.festivals.filter((f) => {
        const matchesFilter = filter === 'All' || f.type === filter;
        const matchesSearch =
          f.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          f.date.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesFilter && matchesSearch;
      }),
    }))
    .filter((monthData) => monthData.festivals.length > 0);

  const totalFestivals = filteredData.reduce((sum, m) => sum + m.festivals.length, 0);

  return (
    <div className="tamil-festivals-page">
      <SEO
        title={`Tamil Festivals ${currentYear} - Complete Calendar with Dates | Tamil Panchangam`}
        description={`Complete list of Tamil festivals in ${currentYear} with dates. Includes Pongal, Thaipusam, Tamil New Year (Puthandu), Chithirai Thiruvizha, Aadi Perukku, Vinayagar Chaturthi, Navaratri, Deepavali, Karthigai Deepam, and all major Tamil Nadu festivals.`}
        keywords={`tamil festivals ${currentYear}, tamil calendar ${currentYear}, pongal ${currentYear}, thaipusam ${currentYear}, tamil new year ${currentYear}, puthandu ${currentYear}, karthigai deepam ${currentYear}, tamil panchangam, tamil nadu festivals`}
        canonicalPath="/tamil-festivals"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'When is Tamil New Year (Puthandu) celebrated?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Tamil New Year (Puthandu) is celebrated on April 14 every year, marking the first day of Chithirai, the first month in the Tamil calendar. It is a fixed solar date and does not change like lunar-based festivals. Families prepare the traditional Maanga Pachadi, a dish made with six flavours symbolizing the different experiences of life.',
                },
              },
              {
                '@type': 'Question',
                name: 'What is the difference between Tamil festivals and North Indian Hindu festivals?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Tamil festivals follow the Tamil solar calendar (Surya Siddhanta), while most North Indian festivals follow a lunisolar calendar. This means some festivals fall on different dates. For example, Tamil Pongal coincides with Makar Sankranti but the celebrations are entirely different. Tamil festivals also have unique observances like Aadi Perukku, Chithirai Thiruvizha, and Karthigai Deepam that are specific to Tamil culture.',
                },
              },
              {
                '@type': 'Question',
                name: 'Why is the month of Margazhi considered special?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Margazhi (mid-December to mid-January) is considered the most spiritually auspicious month in the Tamil calendar. It is believed that the divine energy is closest to earth during this period. Early morning devotional singing of Thiruppavai (by Andal) and Thiruvempavai (by Manikkavasagar) is practised in temples and homes. The famous Chennai Margazhi Music and Dance Season also takes place during this month.',
                },
              },
              {
                '@type': 'Question',
                name: 'What are the main Murugan festivals in Tamil Nadu?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Lord Murugan (Kartikeya/Subramaniam) is the patron deity of Tamil Nadu. The major Murugan festivals include Thaipusam (Thai month — January/February), Vaikasi Visakam (Vaikasi month — May/June, his birthday), Skanda Sashti (Aippasi month — October/November, celebrating his victory over Surapadman at Tiruchendur), and Panguni Uthiram (Panguni month — March/April, celebrating his divine marriage).',
                },
              },
            ],
          },
        ]}
      />

      <div className="container">
        <motion.div
          className="page-header"
          initial={hydrated ? { opacity: 0, y: -20 } : false}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>
            {t('tamilFestivals.title')} <span className="gradient-text">{currentYear}</span>
          </h1>
          <p>{t('tamilFestivals.subtitle')}</p>
        </motion.div>

        {/* Pongal Highlight Banner */}
        <motion.div
          className="tamil-highlight-banner"
          initial={hydrated ? { opacity: 0, scale: 0.95 } : false}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          <span className="tamil-highlight-icon">&#9733;</span>
          <div>
            <strong>{t('tamilFestivals.pongal')} {currentYear}</strong> — {t('tamilFestivals.pongalBanner')}
          </div>
        </motion.div>

        {/* Search and Filter */}
        <motion.div
          className="festivals-controls"
          initial={hydrated ? { opacity: 0, y: 10 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="festivals-search">
            <input
              type="text"
              placeholder={t('tamilFestivals.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="festivals-search-input"
            />
          </div>
          <div className="festivals-filter-tags">
            {typeLabels.map((type) => (
              <button
                key={type}
                className={`filter-tag ${filter === type ? 'active' : ''}`}
                onClick={() => setFilter(type)}
                style={
                  filter === type && type !== 'All'
                    ? { background: typeColors[type], borderColor: typeColors[type], color: '#fff' }
                    : {}
                }
              >
                {typeTranslations[type]}
              </button>
            ))}
          </div>
          <div className="festivals-count">
            {t('tamilFestivals.showing')} {totalFestivals} {totalFestivals !== 1 ? t('tamilFestivals.festivals') : t('tamilFestivals.festival')}
          </div>
        </motion.div>

        {/* Festival Months */}
        <div className="festivals-grid">
          {filteredData.map((monthData, idx) => (
            <motion.div
              key={monthData.month}
              className="festival-month-card"
              initial={hydrated ? { opacity: 0, y: 20 } : false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * idx }}
            >
              <div className="month-header">
                <div>
                  <h2>{t(`months.${monthData.month}`)}</h2>
                  <span className="tamil-month-name">{monthData.tamilMonth}</span>
                </div>
                <span className="month-count">{monthData.festivals.length} {t('tamilFestivals.festivals')}</span>
              </div>
              <div className="month-festivals">
                {monthData.festivals.map((festival, fIdx) => (
                  <div key={fIdx} className="festival-row">
                    <div className="festival-date">{festival.date.split(' ')[1]}</div>
                    <div className="festival-info">
                      <span className="festival-name">{tf(festival.name)}</span>
                      <span
                        className="festival-type-badge"
                        style={{ background: typeColors[festival.type] || '#757575' }}
                      >
                        {typeTranslations[festival.type] || festival.type}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {filteredData.length === 0 && (
          <div className="no-results">
            <p>{t('tamilFestivals.noResults')}</p>
          </div>
        )}

        {/* Key Highlights */}
        <motion.div
          className="festivals-highlights"
          initial={hydrated ? { opacity: 0, y: 20 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          <h2>{t('tamilFestivals.keyHighlights')} {currentYear}</h2>
          <div className="highlights-grid">
            <div className="highlight-card">
              <div className="highlight-icon">&#127774;</div>
              <h3>{t('tamilFestivals.thaiPongal')}</h3>
              <p>January 14, {currentYear} — Harvest festival dedicated to the Sun God. The most celebrated Tamil festival.</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#127878;</div>
              <h3>{t('tamilFestivals.tamilNewYear')}</h3>
              <p>April 14, {currentYear} — Puthandu marks the beginning of the Tamil calendar year (Chithirai 1).</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#127769;</div>
              <h3>{t('tamilFestivals.deepavali')}</h3>
              <p>November 8, {currentYear} — Festival of Lights celebrated with fireworks, sweets, and oil baths.</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#128293;</div>
              <h3>{t('tamilFestivals.karthigaiDeepam')}</h3>
              <p>November 24, {currentYear} — Festival of lamps. Maha Deepam lit atop Tiruvannamalai hill.</p>
            </div>
          </div>
        </motion.div>

        {/* Bottom SEO Content */}
        <div className="page-bottom-content">
          <h2>Tamil Festivals Calendar — Complete Guide to Tamil Nadu Celebrations</h2>
          <p>The Tamil festival calendar is rooted in the ancient Tamil Panchangam (almanac), which follows a solar-based calendar system. Unlike the lunisolar Hindu calendar used in North India, the Tamil calendar is primarily solar, with each month beginning when the Sun enters a new zodiac sign (Rasi). The twelve Tamil months — Thai, Masi, Panguni, Chithirai, Vaikasi, Aani, Aadi, Avani, Purattasi, Aippasi, Karthigai, and Margazhi — form the foundation of Tamil festival scheduling.</p>

          <h3>Pongal — The Grand Tamil Harvest Festival</h3>
          <p><strong>Pongal</strong> is the most important Tamil festival, celebrated over four days during the Tamil month of Thai (mid-January). Bhogi Pandigai starts the celebrations with the burning of old items to welcome the new. Thai Pongal, the main day, is dedicated to the Sun God (Surya) — families cook the traditional Pongal dish in new pots, letting it overflow as a symbol of abundance. Mattu Pongal honours cattle and farm animals, while Kaanum Pongal is a day for family reunions and outings. Thiruvalluvar Day, observed alongside Kaanum Pongal, honours the great Tamil poet-saint Thiruvalluvar.</p>

          <h3>Key Tamil Festivals Through the Year</h3>
          <p><strong>Thaipusam:</strong> Celebrated during Thai month, this festival honours Lord Murugan (Subramaniam). Devotees perform kavadi attam and other acts of devotion at Murugan temples across Tamil Nadu, especially at Palani and Tiruchendur.</p>
          <p><strong>Chithirai Thiruvizha:</strong> The grand festival at Madurai Meenakshi Amman Temple, celebrated during the Tamil month of Chithirai. The highlight is Meenakshi Thirukalyanam — the celestial wedding of Goddess Meenakshi and Lord Sundareswarar, attracting millions of devotees.</p>
          <p><strong>Aadi Perukku:</strong> Observed on the 18th day of the Tamil month Aadi, this festival celebrates the rising water levels of rivers and the onset of the monsoon. Women offer prayers near rivers and water bodies, seeking fertility and prosperity.</p>
          <p><strong>Karthigai Deepam:</strong> The Tamil festival of lights celebrated during the month of Karthigai. Homes are lit with rows of oil lamps (agal vilakku). The Maha Deepam atop Tiruvannamalai Annamalaiyar Temple hill is visible for miles and is a sacred sight for devotees.</p>

          <h3>Tamil Months and Their Significance</h3>
          <p>Each Tamil month carries cultural and agricultural significance. <strong>Thai</strong> (Jan-Feb) marks the harvest and Pongal. <strong>Masi</strong> (Feb-Mar) brings the sacred Masi Magam bathing festival. <strong>Panguni</strong> (Mar-Apr) is auspicious for celestial weddings (Panguni Uthiram). <strong>Chithirai</strong> (Apr-May) is the Tamil New Year month. <strong>Aadi</strong> (Jul-Aug) is considered powerful for Amman (Goddess) worship. <strong>Purattasi</strong> (Sep-Oct) is the month of Perumal (Vishnu) worship and Saturday fasting. <strong>Margazhi</strong> (Dec-Jan) is the most spiritually auspicious month for devotional music (Thiruppavai, Thiruvempavai).</p>

          <h3>Frequently Asked Questions About Tamil Festivals</h3>
          <div className="faq-seo">
            <div className="faq-seo-item">
              <h4>When is Tamil New Year (Puthandu) celebrated?</h4>
              <p>Tamil New Year (Puthandu) is celebrated on April 14 every year, marking the first day of Chithirai, the first month in the Tamil calendar. It is a fixed solar date and does not change like lunar-based festivals. Families prepare the traditional Maanga Pachadi, a dish made with six flavours symbolizing the different experiences of life.</p>
            </div>
            <div className="faq-seo-item">
              <h4>What is the difference between Tamil festivals and North Indian Hindu festivals?</h4>
              <p>Tamil festivals follow the Tamil solar calendar (Surya Siddhanta), while most North Indian festivals follow a lunisolar calendar. This means some festivals fall on different dates. For example, Tamil Pongal coincides with Makar Sankranti but the celebrations are entirely different. Tamil festivals also have unique observances like Aadi Perukku, Chithirai Thiruvizha, and Karthigai Deepam that are specific to Tamil culture.</p>
            </div>
            <div className="faq-seo-item">
              <h4>Why is the month of Margazhi considered special?</h4>
              <p>Margazhi (mid-December to mid-January) is considered the most spiritually auspicious month in the Tamil calendar. It is believed that the divine energy is closest to earth during this period. Early morning devotional singing of Thiruppavai (by Andal) and Thiruvempavai (by Manikkavasagar) is practised in temples and homes. The famous Chennai Margazhi Music and Dance Season also takes place during this month.</p>
            </div>
            <div className="faq-seo-item">
              <h4>What are the main Murugan festivals in Tamil Nadu?</h4>
              <p>Lord Murugan (Kartikeya/Subramaniam) is the patron deity of Tamil Nadu. The major Murugan festivals include Thaipusam (Thai month — January/February), Vaikasi Visakam (Vaikasi month — May/June, his birthday), Skanda Sashti (Aippasi month — October/November, celebrating his victory over Surapadman at Tiruchendur), and Panguni Uthiram (Panguni month — March/April, celebrating his divine marriage).</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TamilFestivals;
